// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-page {
    min-height: 100vh;
    background: var(--surface, #ffffff);
    color: var(--text-primary, #1a1a2e);
    font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
    display: flex;
    flex-direction: column;
}

.legal-page__header {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 32px;
    background: var(--surface, #ffffff);
    border-bottom: 1px solid var(--border, #e5e7eb);
    backdrop-filter: saturate(180%) blur(8px);
}

.legal-page__brand {
    font-family: 'Outfit', 'Pretendard', sans-serif;
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: var(--primary-600, #9333ea);
    text-decoration: none;
}

.legal-page__brand:hover {
    opacity: 0.85;
}

.legal-page__brand-img {
    display: block;
    height: 28px;
    width: auto;
}

.legal-page__back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-secondary, #6b7280);
    text-decoration: none;
    border: 1px solid var(--border, #e5e7eb);
    border-radius: var(--radius-md, 8px);
    transition: all 0.15s ease;
}

.legal-page__back:hover {
    color: var(--primary-600, #9333ea);
    border-color: var(--primary-600, #9333ea);
    background: var(--primary-50, #faf5ff);
}

.legal-page__container {
    flex: 1 1;
    width: 100%;
    max-width: 840px;
    margin: 0 auto;
    padding: 56px 32px 72px;
}

.legal-page__title {
    margin: 0 0 12px;
    font-size: 32px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: var(--text-primary, #1a1a2e);
}

.legal-page__meta {
    margin: 0 0 40px;
    font-size: 14px;
    color: var(--text-secondary, #6b7280);
    padding-bottom: 24px;
    border-bottom: 1px solid var(--border, #e5e7eb);
}

.legal-page__meta strong {
    color: var(--text-primary, #1a1a2e);
    font-weight: 600;
}

.legal-page__body {
    font-size: 15px;
    line-height: 1.75;
    color: var(--text-primary, #1a1a2e);
}

.legal-page__body section {
    margin-bottom: 36px;
}

.legal-page__body section:last-child {
    margin-bottom: 0;
}

.legal-page__body h2 {
    margin: 0 0 14px;
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary, #1a1a2e);
    letter-spacing: -0.01em;
}

.legal-page__body p {
    margin: 0 0 12px;
    color: var(--text-primary, #1a1a2e);
}

.legal-page__body p strong {
    font-weight: 600;
    color: var(--text-primary, #1a1a2e);
}

.legal-page__body ul {
    margin: 0 0 14px;
    padding-left: 22px;
}

.legal-page__body li {
    margin-bottom: 6px;
    color: var(--text-primary, #1a1a2e);
}

.legal-page__body li strong {
    font-weight: 600;
}

.legal-page__footer {
    border-top: 1px solid var(--border, #e5e7eb);
    padding: 28px 32px;
    text-align: center;
    background: var(--background, #f9fafb);
}

.legal-page__footer-links {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.legal-page__footer-links a {
    color: var(--text-secondary, #6b7280);
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: color 0.15s ease;
}

.legal-page__footer-links a:hover {
    color: var(--primary-600, #9333ea);
}

.legal-page__footer-divider {
    color: var(--text-tertiary, #9ca3af);
    font-size: 14px;
}

.legal-page__footer-copy {
    margin: 0;
    font-size: 13px;
    color: var(--text-tertiary, #9ca3af);
}

`, "",{"version":3,"sources":["webpack://./src/css/LegalPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,mCAAmC;IACnC,wEAAwE;IACxE,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mCAAmC;IACnC,+CAA+C;IAC/C,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,qBAAqB;IACrB,wCAAwC;IACxC,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,SAAO;IACP,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qCAAqC;IACrC,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,oCAAoC;AACxC","sourcesContent":[".legal-page {\n    min-height: 100vh;\n    background: var(--surface, #ffffff);\n    color: var(--text-primary, #1a1a2e);\n    font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n    display: flex;\n    flex-direction: column;\n}\n\n.legal-page__header {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 32px;\n    background: var(--surface, #ffffff);\n    border-bottom: 1px solid var(--border, #e5e7eb);\n    backdrop-filter: saturate(180%) blur(8px);\n}\n\n.legal-page__brand {\n    font-family: 'Outfit', 'Pretendard', sans-serif;\n    font-size: 22px;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    color: var(--primary-600, #9333ea);\n    text-decoration: none;\n}\n\n.legal-page__brand:hover {\n    opacity: 0.85;\n}\n\n.legal-page__brand-img {\n    display: block;\n    height: 28px;\n    width: auto;\n}\n\n.legal-page__back {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 14px;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-secondary, #6b7280);\n    text-decoration: none;\n    border: 1px solid var(--border, #e5e7eb);\n    border-radius: var(--radius-md, 8px);\n    transition: all 0.15s ease;\n}\n\n.legal-page__back:hover {\n    color: var(--primary-600, #9333ea);\n    border-color: var(--primary-600, #9333ea);\n    background: var(--primary-50, #faf5ff);\n}\n\n.legal-page__container {\n    flex: 1;\n    width: 100%;\n    max-width: 840px;\n    margin: 0 auto;\n    padding: 56px 32px 72px;\n}\n\n.legal-page__title {\n    margin: 0 0 12px;\n    font-size: 32px;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    color: var(--text-primary, #1a1a2e);\n}\n\n.legal-page__meta {\n    margin: 0 0 40px;\n    font-size: 14px;\n    color: var(--text-secondary, #6b7280);\n    padding-bottom: 24px;\n    border-bottom: 1px solid var(--border, #e5e7eb);\n}\n\n.legal-page__meta strong {\n    color: var(--text-primary, #1a1a2e);\n    font-weight: 600;\n}\n\n.legal-page__body {\n    font-size: 15px;\n    line-height: 1.75;\n    color: var(--text-primary, #1a1a2e);\n}\n\n.legal-page__body section {\n    margin-bottom: 36px;\n}\n\n.legal-page__body section:last-child {\n    margin-bottom: 0;\n}\n\n.legal-page__body h2 {\n    margin: 0 0 14px;\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary, #1a1a2e);\n    letter-spacing: -0.01em;\n}\n\n.legal-page__body p {\n    margin: 0 0 12px;\n    color: var(--text-primary, #1a1a2e);\n}\n\n.legal-page__body p strong {\n    font-weight: 600;\n    color: var(--text-primary, #1a1a2e);\n}\n\n.legal-page__body ul {\n    margin: 0 0 14px;\n    padding-left: 22px;\n}\n\n.legal-page__body li {\n    margin-bottom: 6px;\n    color: var(--text-primary, #1a1a2e);\n}\n\n.legal-page__body li strong {\n    font-weight: 600;\n}\n\n.legal-page__footer {\n    border-top: 1px solid var(--border, #e5e7eb);\n    padding: 28px 32px;\n    text-align: center;\n    background: var(--background, #f9fafb);\n}\n\n.legal-page__footer-links {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n}\n\n.legal-page__footer-links a {\n    color: var(--text-secondary, #6b7280);\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 500;\n    transition: color 0.15s ease;\n}\n\n.legal-page__footer-links a:hover {\n    color: var(--primary-600, #9333ea);\n}\n\n.legal-page__footer-divider {\n    color: var(--text-tertiary, #9ca3af);\n    font-size: 14px;\n}\n\n.legal-page__footer-copy {\n    margin: 0;\n    font-size: 13px;\n    color: var(--text-tertiary, #9ca3af);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
